var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortsYtbBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.722 90.007 c -1.789 0 -3.588 -0.266 -5.35 -0.802 c -4.689 -1.426 -8.552 -4.587 -10.878 -8.903 c -4.518 -8.409 -1.74 -18.991 6.323 -24.094 c 1.283 -0.667 2.48 -1.35 3.715 -2.079 c -1.047 -0.614 -2.045 -1.189 -3.07 -1.762 c -4.949 -2.859 -7.99 -6.861 -8.806 -11.582 c -1.085 -6.409 -1.087 -14.509 8.599 -20.335 c 7.856 -4.696 15.914 -9.297 23.707 -13.747 c 2.584 -1.475 5.169 -2.951 7.753 -4.435 c 5.097 -2.903 11.394 -3.018 16.853 -0.307 c 5.51 2.736 9.263 7.886 10.04 13.776 c 1.131 7.532 -2.631 15.056 -9.362 18.704 c -1 0.565 -1.958 1.122 -2.892 1.679 c 0.212 0.126 0.42 0.252 0.626 0.376 c 0.733 0.442 1.44 0.867 2.162 1.275 c 5.543 3.12 9.042 8.417 9.599 14.53 c 0.549 6.04 -1.894 11.799 -6.702 15.8 c -1.545 1.256 -3.291 2.239 -4.979 3.191 c -0.5 0.281 -0.999 0.563 -1.492 0.851 c -7.995 4.658 -17.48 10.163 -27.21 15.667 C 35.654 89.268 32.703 90.007 29.722 90.007 z M 60.329 2.007 c -2.663 0 -5.287 0.667 -7.622 1.997 c -2.583 1.483 -5.169 2.96 -7.754 4.435 c -7.785 4.446 -15.834 9.042 -23.67 13.726 c -6.839 4.113 -9.129 9.581 -7.657 18.282 c 0.899 5.198 4.75 8.406 7.823 10.18 c 1.49 0.833 2.931 1.675 4.553 2.636 c 0.303 0.18 0.489 0.506 0.49 0.857 c 0.001 0.353 -0.184 0.68 -0.486 0.86 c -1.806 1.083 -3.444 2.054 -5.196 2.96 c -7.105 4.5 -9.579 13.925 -5.556 21.412 c 2.073 3.847 5.518 6.666 9.699 7.938 c 4.185 1.272 8.603 0.833 12.438 -1.231 c 9.702 -5.489 19.18 -10.99 27.169 -15.645 c 0.502 -0.292 1.01 -0.578 1.519 -0.864 c 1.615 -0.91 3.285 -1.851 4.69 -2.993 c 4.286 -3.567 6.47 -8.7 5.981 -14.075 c -0.495 -5.448 -3.626 -10.175 -8.589 -12.969 c -0.74 -0.418 -1.462 -0.853 -2.212 -1.304 c -0.648 -0.391 -1.318 -0.794 -2.042 -1.211 c -0.305 -0.176 -0.495 -0.5 -0.5 -0.852 c -0.005 -0.352 0.176 -0.681 0.476 -0.866 c 1.405 -0.865 2.843 -1.712 4.396 -2.589 c 6.009 -3.257 9.359 -9.955 8.35 -16.675 c -0.692 -5.246 -4.037 -9.824 -8.95 -12.264 C 65.331 2.588 62.813 2.007 60.329 2.007 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.55 59.249 c -0.172 0 -0.345 -0.045 -0.5 -0.134 c -0.31 -0.179 -0.501 -0.509 -0.501 -0.866 V 32.127 c 0 -0.357 0.19 -0.687 0.5 -0.866 c 0.308 -0.179 0.69 -0.179 1 0 l 22.595 13.031 c 0.309 0.178 0.5 0.508 0.5 0.865 s -0.189 0.687 -0.499 0.867 l -22.594 13.09 C 36.897 59.204 36.724 59.249 36.55 59.249 z M 37.55 33.858 v 22.655 L 57.147 45.16 L 37.55 33.858 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortsYtbBorder);
export default __webpack_public_path__ + "static/media/shorts_ytb_border.81f5fc9d5664290c2b72b94c99e92120.svg";
export { ForwardRef as ReactComponent };